// Importa lo SCSS specifico per il blocco
import "./_gift-card.scss";

document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".image-cards-slider");

  sliders.forEach((slider) => {
    new Swiper(slider, {
      effect: "cards",
      grabCursor: true,
      navigation: {
        nextEl: ".swiper-cards-button-next",
        prevEl: ".swiper-cards-button-prev",
      },
      pagination: {
        el: ".swiper-cards-pagination", // Selettore del contenitore della paginazione
        clickable: true, // Rende i puntini cliccabili
      },
    });
  });
});
